import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=236a25a5&scoped=true"
import script from "./reset-password.ts?vue&type=script&lang=ts&external"
export * from "./reset-password.ts?vue&type=script&lang=ts&external"
import style0 from "./reset-password.scoped.scss?vue&type=style&index=0&id=236a25a5&prod&scoped=true&lang=scss&external"
import style1 from "./reset-password.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a25a5",
  null
  
)

export default component.exports